const symbolParse = (input) => {

	if (typeof input !== "string") {
		return input;
	}

	let res = input
		.replace(/<p>/g, '')
		.replace(/<\/p>/g, '')
		.replace(/&hellip;/g, '...')
		.replace(/&amp;/g, '&')
		.replace(/&#8217;/g, "'")
		.replace(/&#8211;/g, ' - ')
		.replace(/&#8221;/g, '"')
		.replace(/&#8220;/g, '"')
		.replace(/<div>/g, '')
		.replace(/<\/div>/g, '')
		.replace(/<span>/g, '')
		.replace(/<\/span>/g, '')
		.replace(/&#038;/g, '&');

	return res;
}

module.exports = { symbolParse }